/**
 * Traduz o nome técnico de uma function call do assistente (tool_calls do
 * historicChat) pra um label legível por quem não é técnico. Cobre as
 * funções de openaiService.js/assistantController.js/registroController.js/
 * scheduling.js/delivery.js, mais as duas específicas do canal de voz
 * (voiceTurnService.js) — esse canal grava no mesmo historicChat via
 * addMessage, então podem aparecer aqui também.
 */
const FUNCTION_CALL_LABELS: Record<string, string> = {
  mensagemSimples: "💬 Enviou uma mensagem",
  mensagemComBotoes: "🔘 Enviou uma mensagem com botões",
  mensagemCatalogo: "🛒 Enviou um catálogo",
  mensagemChavePix: "🔑 Enviou uma chave Pix",
  mensagemOtp: "🔐 Enviou um código de verificação",
  ignorarMensagem: "🙈 Decidiu ignorar a mensagem",
  buscarNaBase: "🔎 Consultou a base de conhecimento",
  obterDataHoraAtualComDias: "🗓️ Consultou a data e hora atual",
  salvarNaMemoria: "🧠 Salvou uma informação na memória",
  solicitarAtendimentoHumano: "🙋 Solicitou atendimento humano",
  executarWebhook: "🔗 Chamou uma integração externa",
  cadastrarUsuario: "📝 Cadastrou dados do cliente",
  atualizarRegistro: "📋 Atualizou um registro",
  buscarCliente: "👤 Consultou o cadastro do cliente",
  listarServicos: "🧾 Consultou os serviços disponíveis",
  listarDias: "📅 Consultou os dias disponíveis",
  listarHoras: "⏰ Consultou os horários disponíveis",
  criarAgendamento: "✅ Criou um agendamento",
  editarAgendamento: "✏️ Editou um agendamento",
  listarCategorias: "📚 Consultou as categorias do cardápio",
  listarItens: "🍔 Consultou os itens do cardápio",
  verPedido: "🧾 Consultou um pedido",
  listarPedidosCliente: "📦 Consultou os pedidos do cliente",
  criarPedido: "🛍️ Criou um pedido",
  editarPedido: "✏️ Editou um pedido",
  cancelarPedido: "❌ Cancelou um pedido",
  textoParaLigacao: "📞 Respondeu na ligação",
  naoPrecisaResponder: "🔇 Decidiu não responder na ligação",
};

export function getFunctionCallLabel(name: string): string {
  return FUNCTION_CALL_LABELS[name] || `⚙️ Chamou uma função personalizada: ${name}`;
}
